import * as React from "react";
import * as ENUM from "@dpdgroupuk/redback-enums";
import useTheme from "@material-ui/core/styles/useTheme";
import SafePlace from "../Icons/SafePlace";
import Upgrade from "../Icons/Upgrade";
import Pickup from "../Icons/Pickup";
import Precise from "../Icons/Precise";
import Neighbour from "../Icons/Neighbour";
import DeliveryDate from "../Icons/DeliveryDate";
import Depot from "../Icons/Depot";
import AlternateAddress from "../Icons/AlternateAddress";
import Informed from "../Icons/Informed";
import ChangeDate from "../Icons/ChangeDate";
import Cancel from "../Icons/Cancel";
import PickupLockerBlue from "../Icons/PickupLockerBlue";
import PickupLockerRed from "../Icons/PickupLockerRed";
import { THEMES } from "../../themes";
export const ParcelOptionIcon = ({
  actionCode,
  className
}) => {
  const activeTheme = useTheme();

  switch (actionCode) {
    case ENUM.PARCEL_ACTION_CODE.DTN:
      return /*#__PURE__*/React.createElement(Neighbour, {
        className: className
      });

    case ENUM.PARCEL_ACTION_CODE.ALA:
      return /*#__PURE__*/React.createElement(AlternateAddress, {
        className: className
      });

    case ENUM.PARCEL_ACTION_CODE.RED:
      return /*#__PURE__*/React.createElement(DeliveryDate, {
        className: className
      });

    case ENUM.PARCEL_ACTION_CODE.ONE:
      return /*#__PURE__*/React.createElement(Precise, {
        className: className
      });

    case ENUM.PARCEL_ACTION_CODE.PKU:
      return /*#__PURE__*/React.createElement(Pickup, {
        className: className
      });

    case ENUM.PARCEL_ACTION_CODE.PKL:
      return activeTheme.name === THEMES.BLUE_LIGHT ? /*#__PURE__*/React.createElement(PickupLockerBlue, {
        className: className
      }) : /*#__PURE__*/React.createElement(PickupLockerRed, {
        className: className
      });

    case ENUM.PARCEL_ACTION_CODE.SFP:
      return /*#__PURE__*/React.createElement(SafePlace, {
        className: className
      });

    case ENUM.PARCEL_ACTION_CODE.TBC:
      return /*#__PURE__*/React.createElement(Depot, {
        className: className
      });

    case ENUM.PARCEL_ACTION_CODE.UPG:
      return /*#__PURE__*/React.createElement(Upgrade, {
        className: className
      });

    case ENUM.PARCEL_ACTION_CODE.KMI:
      return /*#__PURE__*/React.createElement(Informed, {
        className: className
      });

    default:
      {
        return null;
      }
  }
};
export const CollectionOptionIcon = ({
  actionCode,
  className
}) => {
  switch (actionCode) {
    case ENUM.COLLECTION_ACTION_CODE.CFN:
      return /*#__PURE__*/React.createElement(Neighbour, {
        className: className
      });

    case ENUM.COLLECTION_ACTION_CODE.SFP:
      return /*#__PURE__*/React.createElement(SafePlace, {
        className: className
      });

    case ENUM.COLLECTION_ACTION_CODE.CHD:
      return /*#__PURE__*/React.createElement(ChangeDate, {
        className: className
      });

    case ENUM.COLLECTION_ACTION_CODE.CAN:
      return /*#__PURE__*/React.createElement(Cancel, {
        className: className
      });

    default:
      {
        return null;
      }
  }
};